<template>
	<div class="m-t-sm" data-testid="alerts">
		<div v-if="errorsOfType.length === 1" class="form-group alert alert-danger alert-icon" role="alert">
			{{ errorsOfType[0].message }}
		</div>
		<div v-else-if="errorsOfType.length > 1" class="form-group alert alert-danger alert-icon" role="alert">
			<ul>
				<li v-for="(error, index) in errorsOfType" :key="index">{{ error.message }}</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'InlineAlert',
	props: {
		errors: {
			type: Array,
			required: true
		},
		types: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			errorsOfType: []
		};
	},
	watch: {
		errors: function(val) {
			this.setErrors(val);
		}
	},
	mounted() {
		this.setErrors(this.errors);
	},
	methods: {
		setErrors(_propsErrors) {
			const _errors = [];
			for (const err of _propsErrors) {
				if (this.types.includes(err.name)) {
					_errors.push(err);
				}
			}
			this.errorsOfType = _errors;
		}
	}
});
</script>
